import { ActionReducerMap } from '@ngrx/store';
import { ClientSidePermissionStates } from '../states';
import * as fromCientSidePermissionsReducers from './client-side-permission.reducers';

export const clientSidePermissionsReducers: ActionReducerMap<ClientSidePermissionStates> = {
  clientSide: fromCientSidePermissionsReducers.clientSidePermissionsReducers
}
